export const DOCUSIGN_DASHBOARD_RETURN_PARAM = "q2bDocuSignReturn";

export const ZIPCODE_NOT_AVAILABLE_MSG = "No data available for this ZIP code";

export function toError(e) {
  if (e instanceof Error) return e;
  const msg = e?.message ? String(e.message) : String(e);
  return new Error(msg);
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function getDocuSignDashboardReturnUrl() {
  if (typeof window === "undefined") return `/?${DOCUSIGN_DASHBOARD_RETURN_PARAM}=dashboard`;

  const url = new URL(window.location.href);
  url.searchParams.set(DOCUSIGN_DASHBOARD_RETURN_PARAM, "dashboard");
  return `${url.pathname}${url.search}${url.hash}`;
}
